import { Game } from "phaser";
import { Boot } from "./scenes/boot";
import { BaseScene } from "./scenes/basescene";
import VirtualJoystickPlugin from 'phaser3-rex-plugins/plugins/virtualjoystick-plugin.js';

export class App extends Game {

    public quality: number = 1;

    public gameWidth: number;
    public gameHeight: number;


    constructor(config: Phaser.Types.Core.GameConfig, quality: number) {
        super(config);
        this.gameWidth = Number(config.scale?.width || 0);
        this.gameHeight = Number(config.scale?.height || 0);
        this.quality = quality;
    }
}



window.onload = () => {
    const parentElementId = "game";
    let dpr = window.devicePixelRatio;


    //@ts-ignore
    const baseWidth: number = __WIDTH__;
    //@ts-ignore
    const baseHeight: number = __HEIGHT__;

    const game = new App(
        {
            //@ts-ignore
            title: __GAME_TITLE__,
            //@ts-ignore
            version: __VERSION__,
            type: Phaser.AUTO,
            parent: "game",
            backgroundColor: "0x9DC04E",
            fps: { target: 30 },
            scale: {
                mode: Phaser.Scale.FIT,
                width: baseWidth,
                height: baseHeight,

                parent: 'game',
                autoCenter: Phaser.Scale.CENTER_BOTH,
                autoRound: true
            },
            input: {
                mouse: true
            },
            physics: {
                default: "matter",
                matter: {
                    enabled: true,
                    debug: false,
                    enableSleeping: false,
                    gravity: { x: 0, y: 0 }
                }
            },
            plugins: {
                global: [{
                    key: 'rexVirtualJoystick',
                    plugin: VirtualJoystickPlugin,
                    start: true
                },
                    // ...
                ]
            },
            scene: [
                Boot
            ],
        }, 1);

    //@ts-ignore
    window.pauseGame = () => {
        game.scene.getScenes(true).forEach(s => {
            if (s instanceof BaseScene) {
                s.pauseGame();
            }
        });
    }

    //@ts-ignore
    window.resumeGame = () => {
        game.scene.getScenes(true).forEach(s => {
            if (s instanceof BaseScene) {
                s.resumeGame();
            }
        });
    }

}
